import { useAuthStore } from '@/stores/auth.store'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export const useRouteAccess = () => {
    const auth = useAuthStore()

    const route = useRoute()
    const hasRouteAccess = computed(() => {
        const requiredRoles: string[] = (route?.meta?.roles as string[]) || []
        if (requiredRoles.length === 0) {
            return true
        }
        const userRole = auth.user?.role?.type
        return requiredRoles.includes(userRole || '')
    })
    return {
        hasRouteAccess,
    }
}
